/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    small: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    small: false,
};

const Cross = (props) => {
    const classNames = [
        's-cross',
        props.small ? 's-cross_size_small' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            <div className="s-cross__element s-cross__element_top" />
            <div className="s-cross__element s-cross__element_bottom" />
        </props.componentClass>
    );
};

Cross.propTypes = propTypes;

Cross.defaultProps = defaultProps;

export default Cross;
